import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { EMAIL_STATISTICS_API } from '../../../mailing/email-statistics/api/email-statistics-api';
import { RemovalConditionsInterface, RemovalConditionsUpdateInterface } from '../types/removal-conditions-interface';
export function useRemovalConditionsUpdate() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put,
      showFieldsErrorToast: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      removalConditionsUpdate: newData => fetcher(`${EMAIL_STATISTICS_API}/contact/removal-conditions`, newData)
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}